<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex"   justify="space-between"  class="sub-title" >
        <div >
          预约渠道：
          <el-button type="primary" size="small" icon="el-icon-document-add" @click="create" v-if="permission.registration_channel_create">新建</el-button>
        </div>
      </el-row>
    </el-header>
    <el-main style="padding: 0px;">
      <el-table     @filter-change="filterChanged"    @sort-change="handleSortChange"    v-loading='meta.loading'  :data="entities.items" stripe class="main-table">
        <el-table-column
          label="No"
          type="index"
          min-width="120"
          sortable="custom"
          align="center"

        >
          <template slot-scope="scope">
              {{(entities.index) * entities.size + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column sortable="custom"  label="名称"  min-width="120" prop="name"></el-table-column>
        <el-table-column sortable="custom"   label="编码" prop="code"></el-table-column>
        <el-table-column sortable="custom"  label="对接方案" min-width="100" prop="dockingSolution">
          <template slot-scope="scope">
            {{ scope.row.dockingSolution | dictText('DockingSolution')}}
          </template>
        </el-table-column>
        <el-table-column sortable="custom"   label="服务器地址" min-width="150" prop="serverAddress"></el-table-column>
        <el-table-column sortable="custom"  label="号源分配" min-width="100"  prop="alloc"></el-table-column>
        <el-table-column sortable="custom" label="备注" prop="memo"></el-table-column>
        <el-table-column sortable="custom" label="停用">
          <template slot-scope="scope">
            <span v-if="scope.row.disabled">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"  align="center" fixed="left"  width="100">
          <template slot-scope="scope">
            <span v-if="permission.registration_channel_edit">
              <el-button type="primary" plain size="mini" circle icon="el-icon-edit" @click="edit(scope.row)"></el-button>
            </span>
            <span v-else>
              <el-button type="primary" plain size="mini" circle icon="el-icon-edit" title="无权限" disabled></el-button>
            </span>
            <el-popconfirm title="确定要删除吗?" icon-color="red" @confirm="del(scope.row)" style="margin-left:5px;margin-right:5px;" v-if="permission.registration_channel_delete">
              <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <editor v-model="entity" :visible.sync="meta.showEditor" @queryChannels="queryEntities"></editor>
    <pagination  :entities='entities'  @queryEntities='queryEntities' :condition='condition'/>
  </el-container>
</template>

<script>

import api from './api'
import { mapGetters } from "vuex";
export default {
  components: {
    "editor": () => import("./editor"),
     pagination: ()=> import("@/components/_com/pagination")
  },
  data() {
    return {
      meta: {
        showEditor: false,
        loading: false,
      },
      condition: {
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20,
      },
      entities: {},
      entity: {}
    }
  },
  methods: {
     handleSortChange ({prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.queryEntities();
    },
       filterChanged(options) {
      Object.assign(this.condition, options);
      this.queryEntities();
    },
    create() {
      this.entity = {id: null, rota: []};
      this.$nextTick(() => {
        this.meta.showEditor = true
      })
    },
    edit(row) {
      this.entity = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.meta.showEditor = true;
      })
    },
    del(row) {

      api.delChannel(row.id).then(res => {
        this.$message.success('删除成功')
        this.queryEntities();
        this.$store.dispatch("unloadDicts", ["AppointmentChannel"]);
        this.$store.dispatch("loadDicts", ["AppointmentChannel"]);
      }, msg => {
        this.$message({
          type: 'error',
          message: msg
        });
      });
    },
    queryEntities() {
      this.meta.loading = true;
      api.queryChannels(this.condition).then(res => {
        res.items.map(item => {
          item.rota = [item.ifDept ? "科室排班" : "", item.ifExpert ? "专家排班" : ""].filter(item => item !== "")
        })
        this.$set(this, "entities", res);
      }).catch(reason => {
        console.log('Getting registration number type failure:', reason);
      }).finally(()=>{
         this.meta.loading = false;
      })
    }
  },
  created() {
    this.queryEntities();
  },
  computed: {
  ...mapGetters(["permission"]),
  }
}
</script>

<style scoped>

</style>
